import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_RESULT_FEATURE_KEY,
  PaymentResultState,
} from './paymentResult.slice';

export const getPaymentResultState = (rootState: any): PaymentResultState =>
  rootState[PAYMENT_RESULT_FEATURE_KEY];

export const selectFinalState = createSelector(
  getPaymentResultState,
  (s) => s.finalState,
);

export const selectPaymentResultMessage = createSelector(
  getPaymentResultState,
  (s) => s.message,
);
